import { PricingPartnerFilters } from './pricing-partner.state';

export const PRICING_PARTNER_NAME = 'PricingPartner';

export class LoadPricingPartnersListAction {
  static type = `[${PRICING_PARTNER_NAME} LoadPricingPartnersListAction]`;

  constructor(
    public filters: PricingPartnerFilters,
    public pageToLoad = 1
  ) {}
}
export class GetPricingPartnerAction {
  static type = `[${PRICING_PARTNER_NAME} SetPricingPartnersAction]`;

  constructor(public id: string) {}
}

export class LoadPricingPartnerBundlesAction {
  static type = `[${PRICING_PARTNER_NAME} LoadPricingPartnerBundlesAction]`;

  constructor() {}
}

export class AddPricingPartnerBundleAction {
  static type = `[${PRICING_PARTNER_NAME} AddPricingPartnerBundleAction]`;

  constructor(
    public partnerId: string,
    public bundleId: string,
    public price: number,
    public validFrom: Date
  ) {}
}

export class UpdatePricingPartnerAction {
  static type = `[${PRICING_PARTNER_NAME} UpdatePricingPartnerAction]`;

  constructor(
    public partnerId: string,
    public body: { currency?: string; notes?: string }
  ) {}
}
export class UpdatePricingPartnerBundlePriceAction {
  static type = `[${PRICING_PARTNER_NAME} UpdatePricingPartnerBundlePriceAction]`;

  constructor(
    public partnerId: string,
    public pivotId: string,
    public price: number
  ) {}
}

export class DeletePricingPartnerBundlePriceAction {
  static type = `[${PRICING_PARTNER_NAME} DeletePricingPartnerBundlePriceAction]`;

  constructor(
    public partnerId: string,
    public pivotId: string
  ) {}
}

export class ApprovePricingPartnerPriceRequestAction {
  static type = `[${PRICING_PARTNER_NAME} ApprovePricingPartnerPriceRequestAction]`;

  constructor(
    public partnerId: string,
    public requestId: string
  ) {}
}

export class DeletePricingPartnerPriceRequestAction {
  static type = `[${PRICING_PARTNER_NAME} DeletePricingPartnerPriceRequestAction]`;

  constructor(
    public partnerId: string,
    public requestId: string
  ) {}
}
